import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {PromotionList} from "../domain/dtos/promotion-list";
import {PromotionRemote} from "../domain/repository/promotion.remote";

@Injectable({
    providedIn: 'root'
})
export class GetPromotionListUseCase {
    constructor(private promotionRemote: PromotionRemote) {
    }

    execute(itemsPerPage: number, page: number): Observable<PromotionList> {
        return this.promotionRemote.getPromotionList(itemsPerPage, page);
    }
}
